import React from "react";
import { Container, Typography, Box, List, ListItem, ListItemIcon, ListItemText, Alert } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faGavel, faLandmark, faHandshake } from "@fortawesome/free-solid-svg-icons";
import SectionTitle from "../../components/layouts/others/title-section.layout";

const POST20231108: React.FC = () => {
    return (
        <Container sx={{ mb: 5 }}>
            <SectionTitle title="ESPACE INFORMATIONS DES HABITANTS" />
            <Box mt={3} display="flex" justifyContent="center" alignItems="center" mb={2}>
                <FontAwesomeIcon icon={faHandshake} style={{ fontSize: 32, marginRight: 12, color: "#1976d2" }} />
                <Typography
                    variant="h6"
                    fontWeight={700}
                    align="center"
                    color="primary"
                    component="h2"
                >
                    Convention avec une SAFER
                </Typography>
            </Box>

            <Alert severity="warning" icon={<FontAwesomeIcon icon={faExclamationTriangle} />}>
                Alerte vigilance sur la signature d’une convention entre la commune et une SAFER !
            </Alert>

            <Box my={3}>
                <Typography mb={2} color="text.secondary" gutterBottom>
                    La première délibération à l'ordre du jour du Conseil Municipal du <b>jeudi 9 novembre 2023</b> concerne la signature d’une convention avec une Société d’Aménagement Foncier et d’Établissement Rural (<b>SAFER</b>).
                </Typography>

                <Typography variant="subtitle1" fontWeight={600} mb={1}>
                    Pourquoi cette vigilance ?
                </Typography>
                <List>
                    <ListItem alignItems="flex-start">
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faGavel} style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Absence de transparence"
                            secondary={
                                <>
                                    Le Maire soumet une convention sans en détailler les finalités. Un fonctionnement démocratique exige que chaque élu.e dispose d’informations sincères sur les objectifs. Le Maire demande d'approuver des outils sans annoncer comment ils seront utilisés&#160;: <i>ce flou ouvre un large champ d’actions futures.</i>
                                </>
                            }
                        />
                    </ListItem>

                    <ListItem alignItems="flex-start">
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faLandmark} style={{ color: "#388e3c" }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Rôle élargi des SAFER"
                            secondary={
                                <>
                                    <b>Les SAFER agissent aujourd’hui au-delà du secteur agricole.</b> Elles interviennent comme opérateurs fonciers, facilitant des opérations immobilières, bénéficiant d'avantages fiscaux réservés (<a href="https://www.safer.fr/" target="_blank" rel="noopener noreferrer">SAFER.fr</a>). Selon Didier Migaud de la Cour des comptes&#160;: « Les collectivités sont souvent perdantes » (<i>Le Figaro, 11/02/2014</i>).
                                </>
                            }
                        />
                    </ListItem>

                    <ListItem alignItems="flex-start">
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faExclamationTriangle} style={{ color: "#ef6c00" }} />
                        </ListItemIcon>
                        <ListItemText
                            primary="Risques concrets pour la commune"
                            secondary={
                                <>
                                    <ul style={{ marginTop: 0, paddingLeft: '1em' }}>
                                        <li>La SAFER obtient un <b>droit de veille foncière</b> sur toute la commune.</li>
                                        <li>Elle peut <b>préempter une parcelle</b>, que la commune doit ensuite racheter.</li>
                                        <li>Nos fonds de jardins, parcs, bois («&#160;dents creuses&#160;») pourraient alors être urbanisés contre notre volonté.</li>
                                    </ul>
                                    Le vendeur n’est pas obligé d’accepter une préemption partielle, mais la multiplication des divisions de parcelles dans la commune prouve que ce dispositif n’est pas un garde-fou suffisant.
                                </>
                            }
                        />
                    </ListItem>
                </List>
            </Box>

            <Alert severity="error" icon={<FontAwesomeIcon icon={faExclamationTriangle} />}>
                <Typography>
                    Face à ces risques et au manque de confiance envers la politique menée, <b>nous nous opposons à la signature de cette convention</b> lors du Conseil Municipal du 9 novembre 2023.<br />
                    <b>Habitants et élus, restez vigilants !</b>
                </Typography>
            </Alert>
        </Container>
    );
};

export default POST20231108;